import { openPopupWidget } from 'react-calendly';

import { CalendlyPopupProps } from './types';

export const openCalendly = (openCalendlySettings: CalendlyPopupProps): void =>
  openPopupWidget({
    ...openCalendlySettings,
  });
